
import React from 'react';
import {css} from 'emotion';
import {FormEditBlockFieldChoices} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldChoices.jsx';
import {FormEditBlockFieldCode} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldCode.jsx';
import {FormEditBlockFieldHTML} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldHTML.jsx';
import {FormEditBlockFieldKey} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldKey.jsx';
import {FormEditBlockFieldLabel} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldLabel.jsx';
import {FormEditBlockFieldMetadata} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldMetadata.jsx';
import {FormEditBlockFieldRequired} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldRequired.jsx';
import {FormEditBlockFieldReverseValue} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldReverseValue.jsx';
import {FormEditBlockFieldShuffle} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldShuffle.jsx';
import {FormEditBlockFieldType} from '../../../frontend/helpers/FormEdit/FormEditBlockFieldType.jsx';

export const FormEditBlock = function (props) {

  return (<>
    <div
      className={css`
        display: flex;
        flex-direction: column;
        gap: 8px;
      `}
    >
      <div>
        <FormEditBlockFieldType
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldLabel
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldChoices
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldHTML
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldKey
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldRequired
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldShuffle
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldReverseValue
          block={props.block}
        />
      </div>
      <div>
        <FormEditBlockFieldMetadata
          block={props.block}
        />
      </div>
      <div>
        {props.underTheHood && (<>
          <FormEditBlockFieldCode
            block={props.block}
          />
        </>)}
      </div>
    </div>
  </>);

};
